import script from "./ScreenDombvidek.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenDombvidek.vue?vue&type=script&setup=true&lang=js"

import "./ScreenDombvidek.vue?vue&type=style&index=0&id=0d4654da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4654da"]])

export default __exports__